import { getApiParams } from 'api/helpers';
import {
	selectPageModelCategoryId,
	selectPageModelRegionId,
	selectPageModelStoreId,
} from 'store/pageModel';
import { all, call, put, select, takeLatest } from 'typed-redux-saga';
import { sendApplicationForm } from './api';
import {
	sendFormRequest,
	sendFormFailed,
	sendFormSuccess,
	fetchConfiguratorsFailed,
	fetchConfiguratorsRequest,
	fetchConfiguratorsSuccess,
} from './slice';
import { fetchConfigurators, FetchConfiguratorsParams } from './api';

export function* getConfigurators() {
	try {
		const regionCode = yield* select(selectPageModelRegionId);
		const categoryId = yield* select(selectPageModelCategoryId);

		const { url, config } = yield* getApiParams(
			'/services-platform/v0/slp/online-offers-by-category-id'
		);
		const params: FetchConfiguratorsParams = { regionCode, categoryId, types: 'project' };
		const { configurators } = yield* call(fetchConfigurators, url, params, config);
		yield* put(
			fetchConfiguratorsSuccess({
				configurators,
			})
		);
	} catch (error) {
		yield* put(
			fetchConfiguratorsFailed({
				error: { code: error?.status || 500, message: error?.message || null },
			})
		);
	}
}

export function* sendApplicationFormWorker({ payload }) {
	try {
		const storeId = Number(yield* select(selectPageModelStoreId));
		const regionId = Number(yield* select(selectPageModelRegionId));

		const { url, config } = yield* getApiParams('services-platform/v0/slp/leads');
		const { leadId } = yield* call(
			sendApplicationForm,
			url,
			{
				regionId,
				storeId,
				type: 'PLASTER',
				channel: 'LANDING',
				contact: payload,
			},
			config
		);
		yield* put(sendFormSuccess({ leadId }));
	} catch (error) {
		yield put(
			sendFormFailed({
				error: { code: error?.statusCode || 500, message: error?.message || null },
			})
		);
	}
}

export function* roughWorkSaga() {
	return yield* all([
		takeLatest(sendFormRequest, sendApplicationFormWorker),
		takeLatest(fetchConfiguratorsRequest, getConfigurators),
	]);
}
